import {
  faBoxOpen,
  faBarcode,
  faLocationDot,
  faCircleCheck,
  faClockRotateLeft,
  faBuilding,
  faNetworkWired,
  faCertificate,
  faCircleQuestion,
  faAddressCard,
  faCircleInfo,
  faClock,
  faEye,
  faStopwatch,
  faTag,
  faTriangleExclamation,
  faCalendar,
  faComputer,
  faEthernet,
  faGlobe,
  faSatellite,
  faShield,
  faSignal,
  faServer,
  faCheck,
  faUser,
  faDesktop,
  faGears,
  faPlug,
  faQuestionCircle,
  faPaperPlane,
  faBox,
  faInfoCircle,
  faClipboardUser,
  faLock,
  faHourglassEnd,
  faDoorOpen,
  faDoorClosed,
  faHandHolding,
  faCircleXmark,
  faHourglass,
  faKey,
  faPenNib,
  faWifi,
  faFile,
  faMapMarkerAlt,
  faHouseUser,
  faWindowMaximize,
  faSatelliteDish,
  faEyeSlash,
  faUmbrella,
  faLocation,
  faSignature,
  faCircleUser,
  faEnvelope,
  faLayerGroup,
  faHouse,
  faMessage,
  faGear,
  faPlugCircleCheck,
  faDisplay,
  faEarthEurope,
  faLaptop,
  faPencil,
  faPeopleRoof,
  faWarning,
  faTablet,
  faPhone,
  faMobilePhone,
  faPrint,
  faFileArchive,
  faDollar,
  faHourglassHalf,
  faXmark,
  faLink,
  faMicrochip,
  faUsers,
  faShieldVirus,
  faShieldAlt,
  faUserShield,
  faBug,
  faExclamationTriangle,
  faCheckCircle,
  faShieldHalved,
  faBiohazard,
  faObjectGroup,
  faHashtag,
  faSyncAlt
} from "@fortawesome/free-solid-svg-icons";
import { TextSearchFilter, DropdownFilter } from "./FilterTable";
import IconStatus from "./IconStatus";
import { convertDateAndReturn, elpasedTimeAndReturn, timeRemaining, calculateYearsDifference } from "../scripts/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple, faWindows } from "@fortawesome/free-brands-svg-icons";
import MultipleStatus from "./MultipleStatus";
import IconsStatus from "./IconStatus";
import paloLogo from "../assets/palo-logo.png";
import { useTranslation } from "react-i18next";

// Reset value of status for DB
const statusValues = [
  { value: "1", label: "En cours" },
  { value: "2", label: "En attente fournisseur" },
  { value: "4", label: "En attente client" },
  { value: "5", label: "Problème résolu" },
  { value: "749690000", label: "Recherche avancée" },
  { value: "17", label: "En attente d'approbation" },
  { value: "18", label: "Approuvé" },
  { value: "19", label: "Rejeté" },
  { value: "20", label: "Terminé" },
  { value: "21", label: "En attente" },
  { value: "22", label: "Mis à jour" },
  { value: "23", label: "Planifié" },
  { value: "24", label: "Qualifié" },
  { value: "25", label: "En attente de révision des modifications" },
  { value: "26", label: "Devis émis" },
  { value: "27", label: "Devis envoyé" },
  { value: "28", label: "Ciblé" },
  { value: "29", label: "Surveillance" },
  { value: "2500", label: "Nouveau" }
]

export const LogsMonitoringColumns = [
  {
    accessor: "prenom",
    Header: "prénom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "nom",
    Header: "nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "extra.userData.email",
    Header: "email",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faEnvelope,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "extra.userData.entreprise",
    Header: "entreprise",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faBuilding,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "log",
    Header: "message",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faMessage,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "extra.clientIp",
    Header: "ip",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "extra.port",
    Header: "port",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "extra.basePath",
    Header: "chemin",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLink,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "extra.baseUrl",
    Header: "url",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLink,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "created_at",
    Header: "date de création",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClock,
    filterable: true,
    headerColumn: true
  }
];

export const EquipementscolumnsHp = [
  {
    Header: "N° de série",
    accessor: "serial_number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom",
    accessor: "device_name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Model",
    accessor: "model",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.model !== null) {
        return (
          <p className="table-row_cell-column">
            <img
              src={

                "../assets/hp.png"
              }
              className="table-row_cell-img"
            />
            {item.model}
          </p>
        )
      } else {
        return ""
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Salle",
    accessor: "room_name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDoorOpen,
    filterable: true,
    headerColumn: true
  },
];

export const EquipementscolumnsLenovo = [
  {
    Header: "N° de série",
    accessor: "serial_number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom",
    accessor: "device_name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Model",
    accessor: "model",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.model !== null) {
        return (
          <p className="table-row_cell-column">
            <img
              src={

                "../assets/lenovo.png"
              }
              className="table-row_cell-img"
            />
            {item.model}
          </p>
        )
      } else {
        return ""
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Details du model",
    accessor: "model_detail",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Salle",
    accessor: "room_name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDoorOpen,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Date de paiement",
    accessor: "buy_date",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.buy_date ? item.buy_date : <IconStatus value={"Non défini"} />
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Garantie",
    accessor: "garantie",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.garantie ? item.garantie : <IconStatus value={"Non défini"} />
    },
    filterable: true,
    headerColumn: true
  },
];

export const EquipementscolumnsEvoko = [
  {
    Header: "N° de série",
    accessor: "serial_number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Firmware",
    accessor: "firmware",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Adresse MAC",
    accessor: "mac",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Ville",
    accessor: "city",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLocationDot,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Étage",
    accessor: "floor",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBuilding,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Salle",
    accessor: "room_name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDoorOpen,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Pays",
    accessor: "country",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faEarthEurope,
    filterable: true,
    headerColumn: true
  },
];

export const EquipementscolumnsBarco = [
  {
    Header: "Numéro de série",
    accessor: "serial_number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Firmware",
    accessor: "firmware",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Adresse MAC",
    accessor: "mac",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom d'hôte",
    accessor: "hostname",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDesktop,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Modèle",
    accessor: "model",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Code d'accès",
    accessor: "numeric_passcode",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faKey,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.numeric_passcode === "Yes" ?
        <div className="status-intable"><IconStatus value="OUI" /></div> :
        <div className="status-intable"><IconStatus value="NON" /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Résolution",
    accessor: "resolution",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDisplay,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.resolution === "Yes" ?
        <div className="status-intable"><IconStatus value="OUI" /></div>
        : item.resolution === "Preferred" ?
          <div className="status-intable"><IconStatus value="Preferred" /></div>
          : item.resolution === "Auto" ?
            <div className="status-intable"><IconStatus value="Auto" /></div>
            :
            <div className="status-intable"><IconStatus value="NON" /></div>

    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Serveur TP",
    accessor: "tpserver",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faServer,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.tpserver === "Yes" ?
        <div className="status-intable"><IconStatus value="OUI" /></div> :
        <div className="status-intable"><IconStatus value="NON" /></div>
    },
    filterable: true,
    headerColumn: true
  },
];

// Equipements
export const Equipementscolumns = [
  {
    Header: "N° de série",
    accessor: "serial_number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom",
    accessor: "device_name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Produit",
    accessor: "famille.product",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.famille !== null) {
        return (
          <p className="table-row_cell-column">
            {item.famille.constructeur !== null && (
              <img
                src={
                  item.famille.constructeur === "CISCO"
                    ? "../assets/cisco_logo.png"
                    : item.famille.constructeur === "PALOALTO"
                      ? "../assets/palo_logo.png"
                      : item.famille.constructeur === "UCOPIA"
                        ? "../assets/ucopia_logo.png"
                        : null
                }
                className="table-row_cell-img"
                alt="Logo"
              />
            )}
            {item.famille.product}
          </p>
        );
      } else {
        return "";
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "IP",
    accessor: "ip",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
  //Masquer BU et Site pour Demo
  {
    Header: "BU",
    accessor: "bu",
    Filter: DropdownFilter,
    icon: faBuilding,
  },
  {
    Header: "Site",
    accessor: "site.nom",
    Filter: DropdownFilter,
    icon: faLocation,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (typeof item.site === "string") {
        return item.site
      } else if (item.site) {
        return item.site.nom
      } else {
        "Not found"
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Sous contrat",
    accessor: "contract_number",
    Filter: DropdownFilter,
    icon: faCircleCheck,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      const value = item.contract_number;

      const hasContract =
        value &&
        value.trim() !== "" &&
        !value.startsWith("Contract.");
      return (
        <IconStatus
          value={hasContract ? "OUI" : "NON"}
          color={hasContract ? "green" : "red"}
        />
      );
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Fin de support",
    accessor: "famille.end_of_support",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.famille) {
        if (item.famille.end_of_support) {
          const endOfSupportDate = new Date(item.famille.end_of_support);
          const year = endOfSupportDate.getFullYear();
          const value = year === 1970 ? "Non annoncé" : convertDateAndReturn(item.famille.end_of_support);
          const color = year === 1970 ? "orange" : endOfSupportDate > new Date() ? "green" : "red";
          return <IconStatus value={value} color={color} />;
        } else {
          return <IconStatus value={"Non défini"} />;
        }
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    icon: faClockRotateLeft,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Source",
    accessor: "source",
    Filter: DropdownFilter,
    icon: faLocation,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.source) {
        return item.source
      } else {
        "Not found"
      }
    },
    filterable: true,
    headerColumn: true
  },
];


export const Contractscolumns = [
  {
    Header: "Numéro du contrat",
    accessor: "contract_number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Status",
    accessor: "contract_lineStatus",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    Cell: ({ cell }) => {
      const contract = cell.row.original;
      return <IconsStatus value={contract.contract_lineStatus} />
    },
    filterable: true,
    headerColumn: true
  },
  // {
  //   Header: "Client",
  //   accessor: "endCustomerName",
  //   Filter: DropdownFilter,
  //   filter: "rankedMatchSorter",
  //   icon: faUser,
  // },
  {
    Header: "Début du contrat",
    accessor: "startDate",
    icon: faClockRotateLeft,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "endDate",
    Header: "Expiration du contrat",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHourglassEnd,
    Cell: ({ cell }) => {
      const contract = cell.row.original;
      if (contract.endDate) {
        return contract.endDate ?
          <IconsStatus value={contract.endDate} color={new Date(contract.endDate) > new Date() ? "green" : "red"}
          /> :
          <IconStatus value={"Non défini"} />;
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "warrantyEndDate",
    Header: "Garantie constructeur",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShield,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "serviceDescription",
    Header: "Niveau de services",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHandHolding,
    filterable: true,
    headerColumn: true
  },
];

export const Incidentscolumns = [
  {
    Header: "N° de ticket",
    accessor: "ticketnumber",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Type",
    accessor: "casetypecode",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.casetypecode ? (
        <IconStatus value={item.casetypecode} />
      ) : null;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Status",
    accessor: "statuscode",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      const statusLabel = statusValues.find(
        (status) => status.value === item.statuscode
      )?.label;
      return statusLabel ? (
        <IconStatus value={item.statuscode} ticketText={statusLabel} />
      ) : <IconStatus value={"Recherche avancée"} />;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Titre",
    accessor: "title",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Sévérité",
    accessor: "prioritycode",
    Filter: DropdownFilter,
    icon: faTriangleExclamation,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.prioritycode ? <IconStatus value={item.prioritycode} /> : null;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "SLA",
    accessor: "sla",
    Filter: DropdownFilter,
    icon: faStopwatch,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.sla ? <IconStatus value={item.sla} /> : null;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Date de création",
    accessor: "createdon",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell: { value } }) => {
      return convertDateAndReturn(value);
    },
    icon: faClock,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Suivi par",
    accessor: "owninguser_fullname",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faEye,
    filterable: true,
    headerColumn: true
  },
];

export const AuvikAlertscolumns = [
  {
    Header: "Nom",
    accessor: "Entity Name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Type",
    accessor: "Alert name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "status",
    accessor: "Status",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faPlugCircleCheck,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.Status ? <IconStatus value={item.Status} /> : null;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Sévérité",
    accessor: "Severity",
    Filter: DropdownFilter,
    icon: faTriangleExclamation,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.Severity ? <IconStatus value={item.Severity} /> : null;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Détecté le",
    accessor: "Detected On",
    icon: faClock,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item["Detected On"]) {
        return item["Detected On"] ?
          convertDateAndReturn(item["Detected On"])
          :
          <IconStatus value={"Non défini"} />;
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true
  },
]

export const Auvikcolumns = [
  {
    Header: "Nom",
    accessor: "deviceName",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Type",
    accessor: "deviceType",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    filterable: true,
    headerColumn: true
  },
  // {
  //   Header: "Ip",
  //   accessor: "ipAddresses",
  //   Filter: TextSearchFilter,
  //   filter: "rankedMatchSorter",
  //   icon: faNetworkWired,
  //   Cell: ({ value }) => (
  //     <span className="ip-address-auvik">
  //       {value.map((ip, index) => (
  //         <span key={index}>
  //           {ip}
  //           {index < value.length - 1 && ", "}
  //         </span>
  //       ))}
  //     </span>
  //   ),
  // },
  {
    Header: "model",
    accessor: "makeModel",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true
  },
  // {
  //   Header: "status",
  //   accessor: "onlineStatus",
  //   Filter: TextSearchFilter,
  //   filter: "rankedMatchSorter",
  //   icon: faPlugCircleCheck,
  //   Cell: ({ cell }) => {
  //     const item = cell.row.original;
  //     return item.onlineStatus ? <IconStatus value={item.onlineStatus} /> : null;
  //   }
  // },
  {
    Header: "Serie",
    accessor: "serialNumber",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDisplay,
    filterable: true,
    headerColumn: true
  },
];

export const SentinelOneDevicescolumns = [
  {
    Header: "Nom de l'ordinateur",
    accessor: "computerName",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLaptop,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Modèle",
    accessor: "modelName",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faMicrochip,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Groupe",
    accessor: "groupName",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUsers,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Adresse IP externe",
    accessor: "externalIp",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Infecté",
    accessor: "infected",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBiohazard,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      const value = item.infected;
      return (
        <>
          <IconStatus value={t(value)} color={value === "No" ? "green" : "red"} />
        </>
      );
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Mode de mitigation",
    accessor: "mitigationMode",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShieldHalved,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      const value = item.mitigationMode;
      return (
        <>
          <IconStatus value={t(value)} color={value === "protect" ? "green" : "red"} />
        </>
      );
    },
    filterable: true,
    headerColumn: true
  },
];

export const SentinelOneThreatscolumns = [
  {
    Header: "Nom de l'agent",
    accessor: "Agent Computer Name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUserShield,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom de la menace",
    accessor: "Threat Name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBug,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Statut de l'incident",
    accessor: "Incident Status",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faExclamationTriangle,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      const value = item['Incident Status'];
      return (
        <>
          <IconStatus value={t(value)} color={value === "Resolved" ? "green" : "red"} />
        </>
      );
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Classification",
    accessor: "Classification",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShieldAlt,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Statut de mitigation",
    accessor: "Mitigation Status Description",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCheckCircle,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Date d'identification",
    accessor: "Date Identified",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClock,
    filterable: true,
    headerColumn: true
  },
];

export const SecuronixViolationsColumns = [
  {
    Header: "Nom de l'événement",
    accessor: "deviceeventcategory",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBug,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Catégorie",
    accessor: "category",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCheckCircle,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Fait par",
    accessor: "fullname",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Email de l'expéditeur",
    accessor: "emailsender",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom du compte",
    accessor: "accountname",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Ip",
    accessor: "ipaddress",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShieldAlt,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom de la destination",
    accessor: "destinationservicename",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShieldAlt,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "nom du fichier",
    accessor: "filename",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faFile,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "type de fichier",
    accessor: "filetype",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faFileArchive,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Date",
    accessor: "datetime",
    icon: faClock,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original.generationtime;
      if (item) {
        return item ?
          item
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true
  },
];

export const CatoColumns = [
  {
    Header: "ID",
    accessor: "id",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
    link: true
  },
  {
    Header: "Created",
    accessor: "createdAt",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Updated",
    accessor: "updatedAt",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Criticality",
    accessor: "criticality",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Indication",
    accessor: "description",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: false,
    headerColumn: true
  },
  {
    Header: "Source",
    accessor: "source",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Producer",
    accessor: "producer",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Status",
    accessor: "status",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  }
];

export const IeloColumns = [
  {
    Header: "Référence",
    accessor: "Référence",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
    link: true,
    linkType: 'service'
  },
  {
    Header: "Votre rérérence",
    accessor: "Votre rérérence",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Produit",
    accessor: "Produit",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Raison sociale",
    accessor: "Raison sociale",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Contrat",
    accessor: "Contract",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: false,
    headerColumn: true,
    link: true,
    linkType: 'contract'
  },
  {
    Header: "Statut",
    accessor: "Statut",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faExclamationTriangle,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const value = cell.row.original.Statut;
      return (
        <>
          <IconStatus value={t(value)} color={value === "Résilié" ? "red" : value === "En cours de résiliation" ? "orange" : "green"} />
        </>
      );
    },
    filterable: true,
    headerColumn: true
  },
];

export const SecuronixThreatscolumns = [
  {
    Header: "Nom de la menace",
    accessor: "threatname",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBug,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom de la ressource",
    accessor: "resourcename",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShieldAlt,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Type de ressource",
    accessor: "resourcetype",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCheckCircle,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nom du groupe de la ressource",
    accessor: "resourcegroupname",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUserShield,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Catégorie",
    accessor: "category",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUserShield,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Violation par",
    accessor: "violator",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUserShield,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Date de génération",
    accessor: "generationtime",
    icon: faClock,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original.generationtime;
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true
  },
];

export const SecuronixTopThreatscolumns = [
  {
    Header: "Nom du model de menace",
    accessor: "Threat Model name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBug,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Description",
    accessor: "Description",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShieldAlt,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Type de ressource",
    accessor: "resourcetype",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCheckCircle,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Criticalité",
    accessor: "Criticality",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faExclamationTriangle,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const value = cell.row.original.Criticality;
      return (
        <>
          <IconStatus value={t(value)} color={value === "High" ? "red" : value === "Medium" ? "orange" : "green"} />
        </>
      );
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Nombre de violations",
    accessor: "No of violator",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUserShield,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Date de génération",
    accessor: "Generation time",
    icon: faClock,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original["Generation time"];
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true
  },
];

export const Webexcolumns = [
  {
    Header: "Nom",
    accessor: "name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Statuts",
    accessor: "status",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faPlugCircleCheck,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.status && <div className="status-intable"><IconStatus value={item.status} /></div>;
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Produit",
    accessor: "product",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDisplay,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      const product = item?.product || "";
      if (product.includes("B&O")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_b&o.svg" /> {item.product}</p>
      } else if (product === "Cisco Room Navigator") {
        return <p className="table-cell_img"> <img src="./assets/cisco_roomnavigator.svg" /> {item.product} </p>
      } else if (product.includes("Cisco Room Kit")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_roomkit.jpeg" /> {item.product} </p>
      } else if (product.includes("Cisco Codec")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_codecplus.jpeg" /> {item.product} </p>
      } else if (product.includes("Cisco 322")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_322.png" /> {item.product} </p>
      } else if (product.includes("Cisco 730")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_730.png" /> {item.product} </p>
      } else if (product.includes("Cisco Board")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_board55.svg" /> {item.product} </p>
      } else if (product.includes("Cisco Room Bar")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_roombar.jpeg" /> {item.product} </p>
      } else if (product.includes("Cisco Webex DX80")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_dx80.svg" /> {item.product} </p>
      } else if (product.includes("Cisco Webex Share")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_webexshare.png" /> {item.product} </p>
      } else if (product.includes("Cisco Desk Camera")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_deskcamera.svg" /> {item.product} </p>
      } else if (product.includes("Cisco 562")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_562standard.png" /> {item.product} </p>
      } else if (product.includes("Cisco TelePresence MX800") || product.includes("Cisco TelePresence MX700")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_telepresencemx800.png" /> {item.product} </p>
      } else if (product.includes("Cisco TelePresence MX300")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_mx300.jpeg" /> {item.product} </p>
      } else if (product.includes("Cisco TelePresence SX20")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_sx20.svg" /> {item.product} </p>
      } else if (product.includes("Cisco TelePresence SX80")) {
        return <p className="table-cell_img"> <img src="./assets/cisco-sx80.png" /> {item.product} </p>
      } else if (product.includes("Cisco Desk Pro")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_deskpro.svg" /> {item.product} </p>
      } else if (product.includes("Cisco Room 55")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_room55.svg" /> {item.product} </p>
      } else if (product.includes("Cisco Webex DX70")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_dx70.jpeg" /> {item.product} </p>
      } else if (product.includes("Cisco Desk Mini")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_deskmini.png" /> {item.product} </p>
      } else if (product.includes("Cisco Room 70")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_room70.svg" /> {item.product} </p>
      } else if (product.includes("Cisco 722")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_722.jpeg" /> {item.product} </p>
      } else if (product.includes("Cisco 8841")) {
        return <p className="table-cell_img"> <img src="./assets/cisco-8841.png" /> {item.product} </p>
      } else if (product.includes("Cisco 8845")) {
        return <p className="table-cell_img"> <img src="./assets/cisco-8845.png" /> {item.product} </p>
      } else if (product.includes("Cisco 7841")) {
        return <p className="table-cell_img"> <img src="./assets/cisco_7841.png" /> {item.product} </p>
      } else if (product.includes("Cisco 8865")) {
        return <p className="table-cell_img"> <img src="./assets/cisco-8865.png" /> {item.product} </p>
      } else if (product.includes("Cisco 7821")) {
        return <p className="table-cell_img"> <img src="./assets/cisco-7821.png" /> {item.product} </p>
      }
      else {
        return item.product
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    Header: "IP",
    accessor: "ip",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true
  },
];

export const MerakiDevicecolumns = [
  {
    Header: "Nom",
    accessor: "name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Modèle",
    accessor: "model",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Numéro de série",
    accessor: "serial",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true
  },
  {
    Header: "Mac",
    accessor: "mac",
    icon: faNetworkWired,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "status",
    Header: "Status",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.status && <IconStatus value={item.status} />;
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "productType",
    Header: "Type de produit",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "publicIp",
    Header: "Ip publique",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faWifi,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "lastReportedAt",
    Header: "Dernier statut",
    icon: faFile,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      return t(elpasedTimeAndReturn(item.lastReportedAt));
    },
    filterable: true,
    headerColumn: true
  },
];

export const MerakiAllDevicesColumns = [
  {
    Header: "Nom",
    accessor: "name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Modèle",
    accessor: "model",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Numéro de série",
    accessor: "serial",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Mac",
    accessor: "mac",
    icon: faNetworkWired,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Network",
    accessor: "networkName",
    icon: faGlobe,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "status",
    Header: "Status",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.status && <IconStatus value={item.status} />;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "productType",
    Header: "Type de produit",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "publicIp",
    Header: "Ip publique",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faWifi,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "lastReportedAt",
    Header: "Dernier statut",
    icon: faFile,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      return t(elpasedTimeAndReturn(item.lastReportedAt));
    },
    filterable: true,
    headerColumn: true,
  },
];

export const NetworkAlertscolumns = [
  {
    Header: "Catégorie",
    accessor: "category",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faFileArchive,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Sévérité",
    accessor: "severity",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.severity && <IconStatus value={item.severity} />;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Type",
    accessor: "type",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "devices",
    Header: "Appareils",
    filter: "rankedMatchSorter",
    icon: faDesktop,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item?.scope?.devices?.[0]?.name || "NA";
    },
    filterable: true,
    headerColumn: true,
  },
];

export const MerakiClientscolumns = [

  {
    Header: "Nom",
    accessor: "description",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.description === null) {
        return null;
      } else if (item.description.includes("SEP")) {
        return <span> <FontAwesomeIcon icon={faPhone} />{" "}{item.description} </span>
      } else if (item.description.includes("LAP")) {
        return <span> <FontAwesomeIcon icon={faLaptop} />{" "}{item.description} </span>
      } else if (item.description.includes("iPhone")) {
        return <span> <FontAwesomeIcon icon={faMobilePhone} />{" "}{item.description} </span>
      } else if (item.description.includes("iPad")) {
        return <span> <FontAwesomeIcon icon={faTablet} />{" "}{item.description} </span>
      } else if (item.description.includes("RICOH")) {
        return <span> <FontAwesomeIcon icon={faPrint} />{" "}{item.description} </span>
      } else {
        return <span> <FontAwesomeIcon icon={faEthernet} />{" "}{item.description} </span>
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Connecté sur",
    accessor: "recentDeviceName",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faPlug,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Fabriquant",
    accessor: "manufacturer",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHandHolding,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Statut",
    accessor: "status",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.status && <IconStatus value={item.status} />;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Mac",
    accessor: "mac",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Ip",
    accessor: "ip",
    icon: faWifi,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "lastSeen",
    Header: "Dernière vue",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faEye,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return elpasedTimeAndReturn(item.lastSeen);
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "os",
    Header: "OS",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faLaptop,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.os !== null ? item.os : "Autre"
    },
    filterable: true,
    headerColumn: true,
  },
];

export const MerakiLicenceColumn = [
  {
    Header: "Clé",
    accessor: "key",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faKey,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Type",
    accessor: "mode",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Démarré le",
    accessor: "startedAt",
    icon: faClock,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.startedAt) {
        return item.startedAt ?
          convertDateAndReturn(item.startedAt)
          :
          <IconStatus value={"Non défini"} />;
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Demandé le",
    accessor: "claimedAt",
    icon: faClockRotateLeft,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.claimedAt) {
        return item.claimedAt ?
          convertDateAndReturn(item.claimedAt)
          :
          <IconStatus value={"Non défini"} />;
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Durée",
    accessor: "expiration",
    icon: faHourglass,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.expiration) {
        return item.expiration ?
          <IconStatus value={convertDateAndReturn(item.expiration)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Expiré",
    accessor: "expired",
    icon: faHourglass,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <IconStatus value={item?.expired?.toString() === "true" ? "non valide" : "valide"} color={item?.expired?.toString() === "true" ? "red" : "green"} />;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Invalidé le",
    accessor: "invalidatedAt",
    icon: faCircleXmark,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.invalidatedAt) {
        return item.invalidatedAt ?
          <IconStatus value={convertDateAndReturn(item.invalidatedAt)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Edition",
    accessor: "editions",
    icon: faPenNib,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.editions && Array.isArray(item.editions) && item.editions.length > 0) {
        return item.editions[0].edition;
      } else {
        return "";
      }
    },
    filterable: true,
    headerColumn: true,
  },
];

export const MerakiLicencePerDeviceColumn = [
  {
    Header: "Clé",
    accessor: "key",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faKey,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.licenseKey;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Type",
    accessor: "mode",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.licenseType;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Duration",
    accessor: "Duration",
    icon: faCircleXmark,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;

      if (item.activationDate && item.expirationDate) {
        return t(calculateYearsDifference(item.activationDate, item.expirationDate, t));
      } else {
        return "";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Activation Date",
    accessor: "activationDate",
    icon: faClock,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.activationDate) {
        return item.activationDate ?
          <IconStatus value={convertDateAndReturn(item.activationDate)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Expiration Date",
    accessor: "expirationDate",
    icon: faCircleXmark,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.expirationDate) {
        return item.expirationDate ?
          <IconStatus value={convertDateAndReturn(item.expirationDate)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "TimeRemaining",
    accessor: "TimeRemaining",
    icon: faCircleXmark,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      if (item.expirationDate) {
        return <IconStatus value={t(timeRemaining(item.expirationDate, t))} />
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Status",
    accessor: "state",
    icon: faHourglass,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <IconStatus value={item?.state?.toString()} color={item.state?.toString() === "unusedActive" ? "red" : "green"} />;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Order number",
    accessor: "orderNumber",
    icon: faPenNib,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.orderNumber;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Associated device",
    accessor: "name",
    icon: faPenNib,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.name;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    Header: "Associated network",
    accessor: "networkName",
    icon: faPenNib,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.networkName;
    },
    filterable: true,
    headerColumn: true,
  },
];

export const CertificatColumn = [
  {
    accessor: "certificat",
    Header: "Certificat",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCertificate,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "type",
    Header: "Type",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "plaque",
    Header: "Plaque",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faAddressCard,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "fonction",
    Header: "Fonction",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "client",
    Header: "Client",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "pki",
    Header: "Pki",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleQuestion,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "expiration",
    Header: "Expiration",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.expiration) {
        return item.expiration ?
          <IconStatus value={convertDateAndReturn(item.expiration)} />
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
];

export const UmbrellaTraficColumn = [
  {
    accessor: "identities.directory_user",
    Header: "Utilisateur",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        item.identities.directory_user &&
        item.identities.directory_user.split("(")[0]
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "identities.directory_computer",
    Header: "Ordinateur",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faComputer,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        item.identities.directory_computer && item.identities.directory_computer
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "identities.network",
    Header: "Network",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faEthernet,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.identities.network && <IconsStatus value={item.identities.network} />;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "internal_ip",
    Header: "IP interne",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
  },
  {
    accessor: "external_ip",
    Header: "IP Externe",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSatellite,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "domain",
    Header: "Domaine",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGlobe,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "categorie",
    Header: "Politique",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShield,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "date",
    Header: "Date",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCalendar,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.date) {
        return item.date ?
          convertDateAndReturn(item.date)
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
];

export const UmbrellaRoamingColumn = [
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "type",
    Header: "Type",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faQuestionCircle,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "status",
    Header: "Status",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faPlug,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <IconStatus value={item.status} />;
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "lastSyncStatus",
    Header: "Dernier status",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faEye,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "lastSync",
    Header: "Dernière synchr.",
    icon: faCalendar,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return elpasedTimeAndReturn(item.lastSync);
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "version",
    Header: "Version",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGears,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <IconStatus value={item.version} icon />;
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "osVersionName",
    Header: "OS",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDesktop,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      const osVersionName = item?.osVersionName || "Unknown";
      return (
        <>
          <FontAwesomeIcon
            icon={osVersionName.includes("Windows") ? faWindows : faApple}
          />{" "}
          {osVersionName}
        </>
      );
    },
    filterable: true,
    headerColumn: true
  },
];

export const UmbrellaIdentiteColumn = [
  {
    accessor: "identity_name",
    Header: "Identité",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        <div className="ecp-umbrella-identity">
          <FontAwesomeIcon
            icon={
              item.identity_type === "Sites"
                ? faEarthEurope
                : item.identity_type === "Networks"
                  ? faNetworkWired
                  : item.identity_type === "AD Users"
                    ? faUser
                    : item.identity_type === "AD Computers"
                      ? faComputer
                      : item.identity_type === "Roaming Computers"
                        ? faLaptop
                        : null
            }
          />
          <span>
            {item.identity_deleted ? "Identité supprimée" : item.identity_name}
          </span>
        </div>
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "blocked",
    Header: "Requêtes bloquées",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faShield,
    filterable: true,
    headerColumn: true,
  },

  {
    accessor: "requests",
    Header: "Requêtes",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faPaperPlane,
    filterable: true,
    headerColumn: true,
  },
];

export const UmbrellaDestinationColumns = [
  {
    accessor: "domain",
    Header: "Destination",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGlobe,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        <>
          <a href={`https://${item.domain}`} target="_blank">
            {item.domain}
          </a>
        </>
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "categories",
    Header: "Catégories",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBox,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "allowed",
    Header: "Requêtes autorisées",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDoorOpen,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "blocked",
    Header: "Requêtes bloquées",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDoorClosed,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.blocked === 0 ? "-" : item.blocked;
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "requests",
    Header: "Requêtes",
    icon: faPaperPlane,
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true,
  },
];

export const UmbrellaCategoryColumn = [
  {
    accessor: "category",
    Header: "Catégorie",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBox,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "requests",
    Header: "Requêtes",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faPaperPlane,
    filterable: true,
    headerColumn: true,
  },
];

export const PaloLicenceColumn = [
  {
    accessor: "serial_number",
    Header: "N° de série",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "famille.product",
    Header: "Produit",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faInfoCircle,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        <p className="table-row_cell-column">
          <img src={paloLogo} alt='Logo Palo Alto' className="table-row_cell-img" />
          {item.famille ? item.famille.product : "Non défini"}
        </p>
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "device_name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "nom_license",
    Header: "Licence",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClipboardUser,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "auth_code",
    Header: "Auth code",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLock,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "date_fin",
    Header: "Expiration",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHourglassEnd,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.date_fin) {
        return item.date_fin ?
          <IconStatus value={convertDateAndReturn(item.date_fin)} color={new Date(item.date_fin) > new Date() ? "green" : "red"}
          /> :
          null;
      } else {
        return null;
      }
    },
    filterable: true,
    headerColumn: true,
  },
];

export const PaloEquipementColumn = [
  {
    accessor: "serial_number",
    Header: "N° de série",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "device_name",
    Header: "Nom de l'appareil",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "ip",
    Header: "IP",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "site.nom",
    Header: "Site",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLocationDot,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.site ? item.site.nom : "Non défini";
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "famille.product",
    Header: "Produit",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faInfoCircle,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        <p className="table-row_cell-column">
          {item.famille ? item.famille.constructeur === "CISCO" ? <img src="../assets/cisco_logo.png" className="table-row_cell-img" /> : <img src="../assets/palo_logo.png" className="table-row_cell-img" /> : null}
          {item.famille ? item.famille.product : "Non défini"}
        </p>
      );
    },
    filterable: true,
    headerColumn: true,
  },
];

export const AmpColumn = [
  {
    accessor: "hostname",
    Header: "Nom de l'hôte",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHouseUser,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "operating_system",
    Header: "OS",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faWindowMaximize,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        <>
          {" "}
          <FontAwesomeIcon
            icon={
              item.operating_system.includes("Windows") ? faWindows : faApple
            }
          />{" "}
          {item.operating_system ? item.operating_system : ""}
        </>
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "internal_ips",
    Header: "Ips interne",
    icon: faSatelliteDish,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.internal_ips ? (
        <MultipleStatus data={item.internal_ips} />
      ) : (
        ""
      );
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "external_ip",
    Header: "Ip externe",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faNetworkWired,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "policy.name",
    Header: "Policy",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faShield,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.policy ? <IconStatus value={item.policy.name} /> : "";
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "last_seen",
    Header: "Dernière vue",
    icon: faEyeSlash,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.last_seen ? elpasedTimeAndReturn(item.last_seen) : "";
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "isolation.status",
    Header: "Isolation",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faUmbrella,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.isolation.status ? (
        <IconStatus value={item.isolation.status} />
      ) : (
        ""
      );
    },
    filterable: true,
    headerColumn: true,
  },
];

export const UserColumn = [
  {
    accessor: "id",
    Header: "Id",
    icon: faCircleInfo,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "nom",
    Header: "Nom",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faSignature,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "prenom",
    Header: "Prénom",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleUser,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "email",
    Header: "E-mail",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faEnvelope,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "rolesDisplay",
    Header: "Rôles",
    icon: faAddressCard,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return (
        <MultipleStatus data={item.rolesDisplay} />
      )
    },
  },
  {
    accessor: "entreprise_name",
    Header: "Entreprise",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faBuilding,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "holding.nom",
    Header: "Holding",
    icon: faHandHolding,
    filterable: true,
    headerColumn: true,
  },
];

export const SmartAccountColumn = [
  {
    accessor: "accountName",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSignature,
  },
  {
    accessor: "accountDomain",
    Header: "Domaine",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
  },
  {
    accessor: "accountStatus",
    Header: "Status",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faQuestionCircle,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <IconStatus value={item.accountStatus} />;
    },
  },
  {
    accessor: "accountType",
    Header: "Type",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
  },
  {
    accessor: "roles",
    Header: "Rôles",
    icon: faAddressCard,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <MultipleStatus data={item.roles} />;
    },
  },
];

export const VirtualAccountColumn = [
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSignature,
  },
  {
    accessor: "isDefault",
    Header: "Par défaut",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
  },
  {
    accessor: "commerceAccessLevel",
    Header: "Niveau d'accès",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faLayerGroup,
  },
  {
    accessor: "description",
    Header: "Description",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faPenNib,
  },
];

export const PolyColumn = [
  {
    accessor: "id",
    Header: "Id",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true,

  },
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSignature,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "room.name",
    Header: "Pièce",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHouse,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "model.name",
    Header: "Modèle",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "model.description",
    Header: "Description",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faMessage,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "softwareVersion",
    Header: "Software version",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGear,
    filterable: true,
    headerColumn: true,
  },
];

export const VisioColumn = [
  {
    accessor: "fabricant",
    Header: "Constructeur",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faPencil,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.famille !== null) {
        return (
          <p className="table-row_cell-column">
            <img
              src={
                item.fabriquant === "Webex"
                  ? "./assets/webex_logo.png"
                  : "./assets/poly_logo.png"
              }
              className="table-row_cell-img"
            />
            {item.fabriquant}
          </p>
        )
      } else {
        return ""
      }
    },
  },
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSignature,
  },
  {
    accessor: "product",
    Header: "Produit",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
  },
  {
    accessor: "software",
    Header: "Software",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faGear,
  },
];

export const microsoftColumn = [
  {
    accessor: "service",
    Header: "Service",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },

  {
    accessor: "status",
    Header: "Status",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <div className="status-intable"> <IconStatus value={item.status} /></div>
    },
    filterable: true,
    headerColumn: true
  },
]

export const microsoftMessageColumn = [
  {
    accessor: "title",
    Header: "Titre",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },

  {
    accessor: "severity",
    Header: "Sévérité",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faWarning,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <IconStatus value={item.severity} />
    },
    filterable: true,
    headerColumn: true
  },

  {
    accessor: "isMajorChange",
    Header: "Changement majeur",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.isMajorChange === true ?
        <div className="status-intable"><IconStatus value="OUI" /></div> :
        <div className="status-intable"><IconStatus value="NON" /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "services",
    Header: "Services",
    icon: faHandHolding,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <MultipleStatus data={item.services} />
    },
    filterable: true,
    headerColumn: true
  },

  {
    accessor: "lastModifiedDateTime",
    Header: "Dernière modification",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.lastModifiedDateTime) {
        return item.lastModifiedDateTime ?
          elpasedTimeAndReturn(item.lastModifiedDateTime)
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true
  },
]


export const webexIoTColumn = [
  {
    accessor: "displayName",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "type",
    Header: "Type",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.type ? <div className="status-intable"><IconStatus value={item.type} /></div> : null
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "capacity",
    Header: "Capacité",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faPeopleRoof,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return item.capacity ? <div className="status-intable"><IconStatus value={item.capacity} /></div> : null;
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "created",
    Header: "Créé le",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      const date = convertDateAndReturn(item.created)
      return item.created ? date : null
    },
    filterable: true,
    headerColumn: true
  },
]


export const SubscriptionColumn = [
  {
    accessor: "subscriptionId",
    Header: "id",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true,
  },

  {
    accessor: "subscriptionStatus",
    Header: "Statuts",
    Filter: DropdownFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <div className="status-intable"><IconStatus value={item.subscriptionStatus} /></div>
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "offerType",
    Header: "Type d'offre",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHandHolding,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      return <div className="status-intable"><IconStatus value={item.offerType} /></div>
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "duration",
    Header: "Durée",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHourglassHalf,
    Cell: ({ cell }) => {
      const { t } = useTranslation();
      const item = cell.row.original;
      return <div className="status-intable">{item.duration} {t('mois')}</div>
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "startDate",
    Header: "Date de début",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.startDate) {
        return item.startDate ?
          convertDateAndReturn(item.startDate)
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "endDate",
    Header: "Date de fin",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.endDate) {
        return item.endDate ?
          <IconStatus value={convertDateAndReturn(item.endDate)} color={new Date(item.endDate) > new Date() ? "green" : "red"} />
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "transactionType",
    Header: "Type de transaction",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faDollar,
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "last_api_exec",
    Header: "Dernière mise à jour",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original;
      if (item.last_api_exec) {
        return item.last_api_exec ?
          convertDateAndReturn(item.last_api_exec)
          : "Non défini"
      } else {
        return "Non défini";
      }
    },
    filterable: true,
    headerColumn: true,
  },
]

export const ProvisionningColumn = [
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original.name;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "serial_number",
    Header: "Serial_Number",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    Cell: ({ cell }) => {
      const item = cell.row.original.serial_number;
      if (item) {
        const formattedItem = item.split(",").join(", ");
        const splitItems = item.split(",");
        const displayValue = splitItems.length > 2 ? `${splitItems.slice(0, 2).join(", ")} ...` : formattedItem;
        return item ?
          <div className="status-intable"><IconStatus value={displayValue} color={"normal"} /></div>
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "endDate",
    Header: "Date de fin",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.endDate;
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} color={new Date(item) > new Date() ? "no-expired-status-color" : "red"} />
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true,
  },
  {
    accessor: "source",
    Header: "Source",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faHandHolding,
    Cell: ({ cell }) => {
      const item = cell.row.original.source;
      return <div className="status-intable"><IconStatus value={item} color={item === 'subscription' ? 'subscription-status-color' : item === 'pare-feu' ? 'firewall-status-color' : item === 'certificat' ? 'certificat-status-color' : item === 'contract' ? 'contract-status-color' : ''} /></div>
    },
    filterable: true,
    headerColumn: true,
  },
]

export const ArrowSphereAllColumn = [
  {
    accessor: "license_id",
    Header: "id",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original.name;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "Date start",
    Header: "Date d'activation",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.activation_datetime;
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} color={"green"} />
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "endDate",
    Header: "Date de fin",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.expiry_datetime;
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} color={new Date(item) > new Date() ? "green" : "red"} />
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "periodicity",
    Header: "Périodicité",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original.periodicity;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "term",
    Header: "Term",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.term;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "autoRenew",
    Header: "Auto renew",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSyncAlt,
    Cell: ({ cell }) => {
      const item = cell.row.original.autoRenew;
      return <div className="status-intable"><IconStatus value={item ? 'Oui' : 'Non'} color={item ? "green" : "red"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "quantity",
    Header: "Quantity",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    Cell: ({ cell }) => {
      const item = cell.row.original.quantity;
      return <div className="status-intable">{item}</div>
    },
    filterable: true,
    headerColumn: true
  },
]

export const ArrowSphereClientColumn = [
  {
    accessor: "license_id",
    Header: "id",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "name",
    Header: "Nom",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original.name;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "Date start",
    Header: "Date d'activation",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.activation_datetime;
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} color={"green"} />
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "endDate",
    Header: "Date de fin",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.expiry_datetime;
      if (item) {
        return item ?
          <IconStatus value={convertDateAndReturn(item)} color={new Date(item) > new Date() ? "green" : "red"} />
          : <IconStatus value={"Non défini"} />
      } else {
        return <IconStatus value={"Non défini"} />;
      }
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "periodicity",
    Header: "Périodicité",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const item = cell.row.original.periodicity;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "term",
    Header: "Term",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const item = cell.row.original.term;
      return <div className="status-intable"><IconStatus value={item} color={"normal"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "autoRenew",
    Header: "Auto renew",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faSyncAlt,
    Cell: ({ cell }) => {
      const item = cell.row.original.autoRenew;
      return <div className="status-intable"><IconStatus value={item ? 'Oui' : 'Non'} color={item ? "green" : "red"} /></div>
    },
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "quantity",
    Header: "Quantity",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBoxOpen,
    Cell: ({ cell }) => {
      const item = cell.row.original.quantity;
      return <div className="status-intable">{item}</div>
    },
    filterable: true,
    headerColumn: true
  },
]

export const WebexStatisticsColumn = [
  {
    accessor: "starttime",
    Header: "Date de début",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: false,
    headerColumn: true
  },
  {
    accessor: "location",
    Header: "Localisation",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "callinglineid",
    Header: "Ligne appelante",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "callingnumber",
    Header: "Numéro appelant",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "calleridnumber",
    Header: "Numéro affiché",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },

  {
    accessor: "calledlineid",
    Header: "Ligne appelée",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "callednumber",
    Header: "Numéro appelé",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "calloutcome",
    Header: "Résultat de l'appel",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "calltype",
    Header: "Type d'appel",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "duration",
    Header: "Durée de communication (s)",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: true
  },
  {
    accessor: "ringduration",
    Header: "Durée d'attente (s)",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: false,
    headerColumn: true
  },
  {
    accessor: "answerindicator",
    Header: "Indicateur de réponse",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    filterable: true,
    headerColumn: false
  },
  {
    accessor: "isAnswered",
    Header: "Indicateur de réponse",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    headerColumn: true
  },
];

export const AgentInsightcolumns = [
  {
    accessor: "name",
    Header: "name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "department_name",
    Header: "department name",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    headerColumn: true,
    filterable: true
  },
]

export const TicketsInsightcolumns = [
  {
    accessor: "ticket_id",
    Header: "id du ticket",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faBarcode,
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "team",
    Header: "team",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faUser,
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "ticket_type",
    Header: "type",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faTag,
    Cell: ({ cell }) => {
      const ticketType = cell.row.original.ticket_type;
      return ticketType ? (
        <IconStatus
          value={ticketType}
          color={ticketType === "Project Task" || ticketType === "Project" || ticketType === "Risk (Projects)" || ticketType === "Quick Quote" || ticketType === "Quick Time" || ticketType === "Change Request" || ticketType === "Lead"
            ? "green" // Vert pastel
            : ticketType === "Scheduled Task"
              ? "blue_pastel" // Bleu pastel
              : ticketType === "Problem" || ticketType === "Incident" || ticketType === "Alert"
                ? "peche_pastel" // Pêche pastel
                : ticketType === "Firewall Change Request" || ticketType === "Administrator Rights Request" || ticketType === "Shared Drive Access Request" || ticketType === "Service Request"
                  ? "lilas_pastel" // Lilas pastel
                  : ticketType === "New Starter Request" || ticketType === "Leaver Request"
                    ? "pink_pastel" // Rose pastel
                    : ticketType === "Peripherals Request" || ticketType === "Mobile Phone Request" || ticketType === "Laptop Request" || ticketType === "Desktop Request" || ticketType === "Hardware Collection Request" || ticketType === "Print Services Request"
                      ? "yellow_pastel" // Jaune pastel
                      : ticketType === "Software Change" || ticketType === "Software Request"
                        ? "green_water_pastel" // Vert d’eau pastel
                        : ticketType === "Other Hardware" || ticketType === "Network Request"
                          ? "blue_lavande_pastel" // Bleu lavande pastel
                          : ""
          } />
      ) : (
        <IconStatus value={ticketType} />
      );
    },
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "summary",
    Header: "résumé du ticket",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faCircleInfo,
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "date_action",
    Header: "date d'action",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClock,
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "date_creation_ticket",
    Header: "date de création du ticket",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClock,
    headerColumn: true,
    filterable: true
  },
  {
    accessor: "time_spent",
    Header: "temps de travail",
    Filter: TextSearchFilter,
    filter: "rankedMatchSorter",
    icon: faClockRotateLeft,
    Cell: ({ cell }) => {
      const timeSpent = cell.row.original.time_spent;
      const formatTimeSpent = (minutes) => {
        if (minutes >= 60) {
          const hours = Math.floor(minutes / 60);
          const remainingMinutes = minutes % 60;
          return remainingMinutes > 0
            ? `${hours}h${remainingMinutes}min`
            : `${hours}h`;
        } else {
          return `${minutes}min`;
        }
      };

      return formatTimeSpent(timeSpent);
    },
    headerColumn: true,
    filterable: true
  }
];

